import { render, staticRenderFns } from "./secKillAttr.vue?vue&type=template&id=67a3bb0f&scoped=true"
import script from "./secKillAttr.vue?vue&type=script&lang=js"
export * from "./secKillAttr.vue?vue&type=script&lang=js"
import style0 from "./secKillAttr.vue?vue&type=style&index=0&id=67a3bb0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a3bb0f",
  null
  
)

component.options.__file = "secKillAttr.vue"
export default component.exports